module.exports = __webpack_public_path__ + "static/media/1_3.1201fb60.png";